import { configureStore, ThunkAction, Action } from '@reduxjs/toolkit';
import teamScheduleReducer from '../app/slice/teamSchedule.slice';

export const store = configureStore({
  reducer: {
    teamSchedule: teamScheduleReducer,
  },
});

export type AppDispatch = typeof store.dispatch;
export type RootState = ReturnType<typeof store.getState>;
export type AppThunk<ReturnType = void> = ThunkAction<
  ReturnType,
  RootState,
  unknown,
  Action<string>
>;
